import { bindActionCreators, Dispatch } from 'redux'
import { connect } from 'react-redux'

import Plays from 'components/Owner/Plays'
import Dashboard from 'components/Owner/Dashboard/index'
import InitialAssessment from 'components/Owner/InitialAssessment'

import { updateProgressbarAction, resetProgressbarAction } from 'store/actions/common/progressbar'
import { getUserGoalAction } from 'store/actions/owner/playbooks'
import {
  setActiveStepAction,
  getAssessmentQuestionAction,
  saveAssessmentResponseAction,
  getUserAssessmentResponseAction,
  addEditAssessmentAction,
  handleUserGoal,
  initializeOwnerStepperAction,
  getAssessmentResponseByQuestionAction,
  ownerOnBoardingCompletionAction,
  resetAssessment,
} from 'store/actions/owner/initialAssessment'

import { getRecommendedPlaysAssessments } from 'store/actions/owner/account'
import {
  getPlayAction,
  authorizeConnectorAction,
  updatePlayStageAction,
  getPlayAssessmentResponseAction,
  handleCompletePlayAction,
  resetPlayAction,
  getPlayResponseAction,
  savePlayResponseAction,
  saveUserPlayFileAction,
} from 'store/actions/play'
import {
  getAssessmentQuestionSelector,
  getCurrentGoalSelector,
  getAssessmentProgressSelector,
  getAssessmentQuestionOption,
  getUserDataSelector,
} from 'store/selectors/owner'
import {
  getAdvisorDashboardAction,
  getTackleMeetingEventsAction,
  getToolsByTypeAction,
} from 'store/actions/clients'

import {
  getCalendarEventsSelector,
  getUserAvailabilityListSelector,
  getUserMeetingByEventIdSelector,
  getUserAvailableMeetingLocationSelector,
} from 'store/selectors/calendar'
import { getRecommendationsSelector } from 'store/selectors/assessments'

import PlayView from 'components/Owner/Plays/PlayView'

import {
  getUserProfileAction,
  updateUserProfileAction,
  getUserBusinessProfileAction,
  updateUserBusinessProfileAction,
  updateMyToolsAction,
} from 'store/actions/user'

import {
  getOAuthUrlAction,
  getBoAdvisorAction,
  resetOAuthUrlAction,
  getUserMeetingAction,
  handleCyclrOAuthAction,
  getUserConnectorsAction,
  getUserCalendarEventsAction,
  updateCalendarMeetingAction,
  deleteGoogleCalendarEventAction,
  subscribeGoogleCalendarWebhookAction,
  cancelOutLookMeetingAction,
  setUserAvailabilityAction,
  getUserAvailabilityAction,
  setUserMeetingAction,
  updateMeetingStepperAction,
  openSlotsModalAction,
  setIsScheduledAction,
  updateUserCalendarEventAction,
  cancelUserCalendarEventAction,
  getUserAvailabilityHoursAction,
  updateUserAvailabilityHoursAction,
  getAdvisorProfileAction,
  getUserMeetingByEventIdAction,
  openMeetingConfirmationModalBoxAction,
  setCurrentCalendarDateAction,
} from 'store/actions/calendar'

import Calendar from 'components/Calendar'
import Meetings from 'components/Calendar/Meetings'
import BoAdvisor from 'components/Calendar/ScheduleMeetingWithAdvisor/BoAdvisor'
import GoalDetail from 'components/Owner/Goal/GoalDetail'
import { getGoalDetailsAction } from 'store/actions/goal'
import Assessment from 'components/Owner/Goals/Assessment'
import Integrations from 'components/Calendar/Integrations'
import Tools from 'components/Owner/Tools'
import { getPlayResponse, getPlayValue } from 'store/selectors/playBook'
import ConnectedTools from 'components/Owner/Tools/ConnectedTools'
import {
  getAllToolsAction,
  getConnectedToolsAction,
  deauthenticateConnectorAction,
  getMyToolsAction,
  toolConnectionSuccessAction,
} from 'store/actions/clients'
import {
  getCalendarListDetails,
  getCompletedToolsCountSelector,
  getGroupedAllToolsByCategory,
  getGroupedMyToolsByCategory,
  getTackleMeetingSelector,
  getToolDetail,
} from 'store/selectors/clients'
import AllTools from 'components/Owner/Tools/AllTools'
import {
  inputFieldbgColorAction,
  setToolConnectionStatus,
  totalUpComingMeetingsAction,
  uploadFileAction,
} from 'store/actions/common'

import AllToolsModal from 'components/Owner/Tools/AllToolsModal'
import ToolsGuide from 'components/Owner/Tools/ToolsGuide'
import AllToolsBlock from 'components/Owner/Tools/AllToolsBlock'
import { getConnectedPlayAction, savePlayDataAction } from 'store/actions/play'
import PlaysScheduleMeeting from 'components/Owner/Plays/PlaysScheduleMeeting'
import { RootState } from 'App'
import EventForm from 'components/Calendar/EventForm'
import MeetingSchedule from 'components/Calendar/MeetingSchedule'
import ScheduleMeeting from 'components/Calendar/ScheduleMeeting'
import CalendarTools from 'components/Calendar/CalendarTools'
import PlaysAuthentication from 'components/Owner/Plays/PlaysAuthentication'
import UpcomingMeeting from 'components/Calendar/Meetings/UpcomingMeeting'
import BsoClient from 'components/Calendar/BsoClient'
import { getCalendarEvents } from 'components/Dashboard/Advisor/FutureEvents/FutureEvents.helper'
import CreateProfile from 'components/Owner/InitialAssessment/CreateProfile'
import MeetingConfirmation from 'components/Calendar/Meetings/MeetingConfirmation'
import CalendarSettings from 'components/Calendar/CalendarSettings'
import ToolFlyoutMenu from 'components/Owner/Tools/ToolFlyout/ToolFlyoutMenu'

/* --------------------------- Dashboard (Index) --------------------------- */

const dashboardProps = (state: RootState) => {
  const { user, businessProfile } = state.user
  const { businessProfileLoading } = state.loadingStatus
  const businessName = state.user.businessProfile?.businessName
  return {
    businessName,
    businessProfile,
    currentUser: user,
    toastData: getUserDataSelector(state),
    businessProfileLoading,
    isLoadingBigQuery: state.loadingStatus.bigQuery,
    recommendations: getRecommendationsSelector(state),
    isLoadingRecommendations: state.loadingStatus.recommendations,
    assessmentQuestionOption: getAssessmentQuestionOption(state),
    calendarEvents: state.calendar.calendarEvents,
    chatUnreadMessageCount: state.user.chatUnreadMessageCount,
  }
}

function dashboardDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getAssessmentResponseByQuestionAction: getAssessmentResponseByQuestionAction.STARTED,
      getUserBusinessProfileAction: getUserBusinessProfileAction.STARTED,
      updateUserProfileAction: updateUserProfileAction.STARTED,
      getRecommendedPlaysAssessments: getRecommendedPlaysAssessments.STARTED,
      getUserCalendarEventsAction: getUserCalendarEventsAction.STARTED,
      resetRecommendedPlaysAssessments: getRecommendedPlaysAssessments.RESET,
    },
    dispatch
  )
}
export const DashboardContainer = connect(dashboardProps, dashboardDispatch)(Dashboard)

/* --------------------------- Create Event --------------------------- */

const EventFormProps = (state: any) => {
  const { meetingTypes, userAvailabilityHoursList, isUpdateUserAvailabilityLoading } =
    state.calendar
  const { isAvailabilityHoursLoading } = state.loadingStatus
  const userProfile = state.user?.user
  return {
    meetingTypes,
    userAvailabilityHoursList,
    isAvailabilityHoursLoading,
    userProfile,
    isUpdateUserAvailabilityLoading,
  }
}

function EventFormDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getUserAvailabilityHoursAction: getUserAvailabilityHoursAction.STARTED,
      setUserAvailabilityAction: setUserAvailabilityAction.STARTED,
      updateUserAvailabilityHoursAction: updateUserAvailabilityHoursAction.STARTED,
      updateUserProfileAction: updateUserProfileAction.STARTED,
      getUserProfileAction: getUserProfileAction.STARTED,
    },
    dispatch
  )
}
export const CreateEventContainer = connect(EventFormProps, EventFormDispatch)(EventForm)
/*---------------------------- MeetingSchedule---------------------------------------*/
const GetUserAvailabilityProps = (state: RootState) => {
  const {
    boAdvisors,
    isMeetingModalOpen,
    isScheduled,
    advisorProfile,
    isDisabled,
    userAvailabilityStatus,
  } = state.calendar
  const { user } = state.user
  const { list } = state.clients
  const { organizationName } = state.user.user

  return {
    user,
    list,
    boAdvisors,
    isDisabled,
    isScheduled,
    organizationName,
    isMeetingModalOpen,
    userAvailabilityList: getUserAvailabilityListSelector(state),
    userAvailableMeetingLocation: getUserAvailableMeetingLocationSelector(state),
    userAvailabilityStatus,
    advisorProfile,
  }
}

function MeetingScheduleDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getUserAvailabilityAction: getUserAvailabilityAction.STARTED,
      setUserMeetingAction: setUserMeetingAction.STARTED,
      updateMeetingStepperAction,
      getAdvisorDashboardAction: getAdvisorDashboardAction.STARTED,
    },
    dispatch
  )
}
export const MeetingScheduleContainer = connect(
  GetUserAvailabilityProps,
  MeetingScheduleDispatch
)(MeetingSchedule)

/*---------------------------- ScheduleMeetingModalBox------------------------------- */
const ScheduleMeetingModalBoxProps = (state: any, ownProps: any) => {
  const { meetingStepper, userAvailabilityList, boAdvisors, errorMessage, isScheduled } =
    state.calendar

  return {
    meetingStepper,
    userAvailabilityList,
    boAdvisors,
    errorMessage,
    isSuccess: isScheduled,
    ...ownProps,
  }
}
function ScheduleMeetingModalBoxDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getUserAvailabilityAction: getUserAvailabilityAction.STARTED,
      updateMeetingStepperAction: updateMeetingStepperAction,
      getUserAvailabilityActionReset: getUserAvailabilityAction.RESET,
    },
    dispatch
  )
}
export const ScheduleMeetingModalBoxContainer = connect(
  ScheduleMeetingModalBoxProps,
  ScheduleMeetingModalBoxDispatch
)(ScheduleMeeting)

/*---------------------------- Meeting Confirmation------------------------------- */
const meetingConfirmationProps = (state: any) => {
  const { isScheduled, errorMessage } = state.calendar
  let Heading = errorMessage ? 'Sorry' : 'Meeting Confirmed'

  return { Heading, isSuccess: isScheduled }
}
function meetingConfirmationDispatch(dispatch: Dispatch) {
  return bindActionCreators({}, dispatch)
}
export const MeetingConfirmationContainer = connect(
  meetingConfirmationProps,
  meetingConfirmationDispatch
)(MeetingConfirmation)

/* --------------------------- Initial Assessment (Index) --------------------------- */

const inititalAssessmentProps = (state: RootState) => {
  const { steps, activeStep, activeQuestion, isLoadingAssessmentResponse } = state.owner
  const { error, disableLoginSubmit, user, businessProfile } = state.user
  return {
    error: error,
    steps: steps,
    activeQuestion,
    currentUser: user,
    activeStep: activeStep,
    isLoadingAssessmentResponse,
    disableLoginSubmit: disableLoginSubmit,
    isUpdateProfileLoading: state?.user?.isUpdateProfileLoading,
    assessment: getAssessmentQuestionSelector(state),
    onboardedAt: businessProfile.onboardedAt,
  }
}

function initialAssessmentDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      resetAssessment,
      resetProgressbarAction,
      inputFieldbgColorAction,
      initializeOwnerStepperAction,
      setActiveStepAction: setActiveStepAction,
      updateProgressbarAction: updateProgressbarAction,
      getUserProfileAction: getUserProfileAction.STARTED,
      updateUserProfileAction: updateUserProfileAction.STARTED,
      addEditAssessmentAction: addEditAssessmentAction.STARTED,
      getAssessmentQuestionAction: getAssessmentQuestionAction.STARTED,
      saveAssessmentResponseAction: saveAssessmentResponseAction.STARTED,
      getUserBusinessProfileAction: getUserBusinessProfileAction.STARTED,
      updateUserBusinessProfileAction: updateUserBusinessProfileAction.STARTED,
      getUserAssessmentResponseAction: getUserAssessmentResponseAction.STARTED,
      ownerOnBoardingCompletionAction: ownerOnBoardingCompletionAction,
    },
    dispatch
  )
}
export const InitialAssessmentContainer = connect(
  inititalAssessmentProps,
  initialAssessmentDispatch
)(InitialAssessment)

/*----------------------------Create-----------------------------*/
const CreateProfileProps = (state: RootState) => {
  const { activeStep } = state.owner
  return {
    userId: state.user.user.id,
    activeStep: activeStep,
    isUpdateProfileLoading: state?.user?.isUpdateProfileLoading,
  }
}

function CreateProfileDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      updateProgressbarAction: updateProgressbarAction,
      updateUserProfileAction: updateUserProfileAction.STARTED,
      updateUserBusinessProfileAction: updateUserBusinessProfileAction.STARTED,
    },
    dispatch
  )
}
export const CreateProfileContainer = connect(
  CreateProfileProps,
  CreateProfileDispatch
)(CreateProfile)

/* --------------------------- Goal Detail (Index) --------------------------- */

const GoalDetailProps = (state: RootState) => {
  return {
    goalDetails: state.goal.details,
    currentGoal: getCurrentGoalSelector(state),
  }
}

function GoalDetailDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      handleUserGoal,
      getUserGoalAction: getUserGoalAction.STARTED,
      getGoalDetailsAction: getGoalDetailsAction.STARTED,
      getAssessmentQuestionAction: getAssessmentQuestionAction.STARTED,
    },
    dispatch
  )
}
export const GoalDetailContainer = connect(GoalDetailProps, GoalDetailDispatch)(GoalDetail)

/* --------------------------- Goals (Index) --------------------------- */

const assessmentProps = (state: RootState) => {
  const { goals } = state.owner
  const { progressBarIndex, totalSteps } = getAssessmentProgressSelector(state)
  let progress = 0
  if (totalSteps) {
    progress = (progressBarIndex / totalSteps) * 100
  }
  return {
    goals,
    progress,
  }
}

function assessmentDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      addEditAssessmentAction: addEditAssessmentAction.STARTED,
    },
    dispatch
  )
}
export const AssessmentContainer = connect(assessmentProps, assessmentDispatch)(Assessment)

/* --------------------------- Calendar (Index) --------------------------- */

const calendarProps = (state: RootState) => {
  const { user } = state.user
  const { oAuthUrl } = state.calendar
  const {
    userConnectors,
    isSlotsModalOpen,
    isMeetingModalOpen,
    meetingStepper,
    userAvailabilityList,
    calendarConnectionSuccess,
  } = state.calendar

  return {
    user,
    userConnectors,
    isSlotsModalOpen,
    isMeetingModalOpen,
    meetingStepper,
    userAvailabilityList,
    oAuthUrl,
    calendarConnectionSuccess,
  }
}

function calendarDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getUserConnectorsAction: getUserConnectorsAction.STARTED,
      getMyToolsAction: getMyToolsAction.STARTED,
      openSlotsModalAction: openSlotsModalAction,
      updateMeetingStepperAction,
      toolConnectionSuccessAction: toolConnectionSuccessAction.STARTED,
      getOAuthUrlAction: getOAuthUrlAction.STARTED,
      updateUserProfileAction: updateUserProfileAction.STARTED,
      resetOAuthUrlAction,
    },
    dispatch
  )
}
export const CalendarContainer = connect(calendarProps, calendarDispatch)(Calendar)

/**------------------------------------------------------- */
const calendarToolsProps = (state: RootState) => {
  const { oAuthUrl, currentCalendarDate } = state.calendar
  const { isToolsByTypeLoading } = state.loadingStatus
  const { toolsByType } = state.clients

  return {
    oAuthUrl,
    toolsByType,
    isToolsByTypeLoading,
    currentCalendarDate,
  }
}

function calendarToolsDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getUserConnectorsAction: getUserConnectorsAction.STARTED,
      resetOAuthUrlAction,
      getToolsByTypeAction: getToolsByTypeAction.STARTED,
      getOAuthUrlAction: getOAuthUrlAction.STARTED,
      deauthenticateConnectorAction: deauthenticateConnectorAction.STARTED,
      subscribeGoogleCalendarWebhookAction: subscribeGoogleCalendarWebhookAction.STARTED,
      toolConnectionSuccessAction: toolConnectionSuccessAction.STARTED,
      getUserCalendarEventsAction: getUserCalendarEventsAction.STARTED,
      getMyToolsAction: getMyToolsAction.STARTED,
    },
    dispatch
  )
}
export const CalendarToolsContainer = connect(
  calendarToolsProps,
  calendarToolsDispatch
)(CalendarTools)
/**------------------------------------------------------------------ */

const calendarIntegrationsProps = (state: RootState) => {
  const { loadingStatus, userConnectors, oAuthUrl } = state.calendar
  const { user } = state.user

  return {
    user,
    oAuthUrl,
    userConnectors,
    loadingStatus,
  }
}

function calendarIntegrationsDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      resetOAuthUrlAction,
      toolConnectionSuccessAction: toolConnectionSuccessAction.STARTED,
      getOAuthUrlAction: getOAuthUrlAction.STARTED,
      getUserConnectorsAction: getUserConnectorsAction.STARTED,
      handleDisconnect: deauthenticateConnectorAction.STARTED,
      subscribeGoogleCalendarWebhookAction: subscribeGoogleCalendarWebhookAction.STARTED,
    },
    dispatch
  )
}
export const IntegrationsContainer = connect(
  calendarIntegrationsProps,
  calendarIntegrationsDispatch
)(Integrations)

const calanderMeetingsProps = (state: RootState, ownProps?: any) => {
  const {
    cancelMeetingLoading,
    isMeetingModalOpen,
    stepType,
    errorMessage,
    isMeetingDeletion,
    currentCalendarDate,
  } = state.calendar
  const { isDisabled } = state.clients
  const { upcomingEventLoading: calenderEventsLoading } = state.loadingStatus
  const { user } = state.user
  return {
    user,
    stepType,
    isDisabled,
    errorMessage,
    isMeetingDeletion,
    cancelMeetingLoading,
    isMeetingModalOpen,
    calenderEventsLoading,
    events: getCalendarEvents(state.calendar.calendarEvents, state.common.totalUpComingMeeting)
      .calendarEvents,
    upComingEvents: getCalendarEventsSelector(state).upComingEvents,
    userMeeting: getUserMeetingByEventIdSelector(state),
    meetingCalendarDetails: getCalendarListDetails(state),
    currentCalendarDate,
    advisorMeetingRequestButtonEnabled: ownProps?.advisorMeetingRequestButtonEnabled,
  }
}

function calanderMeetingsDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      totalUpComingMeetingsAction: totalUpComingMeetingsAction,
      cancelUserCalendarEventAction: cancelUserCalendarEventAction.STARTED,
      getUserCalendarEventsAction: getUserCalendarEventsAction.STARTED,
      resetUserCalendarEventsAction: getUserCalendarEventsAction.RESET,
      updateCalendarMeetingAction: updateCalendarMeetingAction.STARTED,
      updateUserCalendarEventAction: updateUserCalendarEventAction.STARTED,
      getUserMeetingByEventIdAction: getUserMeetingByEventIdAction.STARTED,
      getMyToolsAction: getMyToolsAction.STARTED,
      openMeetingConfirmationModalBoxAction: openMeetingConfirmationModalBoxAction,
      setCurrentCalendarDateAction: setCurrentCalendarDateAction,
    },
    dispatch
  )
}
export const MeetingsContainer = connect(calanderMeetingsProps, calanderMeetingsDispatch)(Meetings)

const calendarSettingProps = (state: RootState, ownProps?: any) => {
  const { calendarList, hasExternalCalendarConnected } = getCalendarListDetails(state)
  const { isUpdateUserAvailabilityLoading } = state.calendar
  const { user } = state.user
  return {
    meetingCalendarDetails: calendarList,
    hasExternalCalendarConnected,
    isUpdateUserAvailabilityLoading,
    user,
    advisorMeetingRequestButtonEnabled: ownProps?.advisorMeetingRequestButtonEnabled,
  }
}

function calendarSettingDispatch(dispatch: Dispatch) {
  return bindActionCreators({}, dispatch)
}
export const CalenderSettingContainer = connect(
  calendarSettingProps,
  calendarSettingDispatch
)(CalendarSettings)
/* -------------------------- UpcomingMeeting CONTAINER --------------------------- */

const upcomingMeetingProps = (state: RootState) => {
  const { cancelMeetingLoading, isMeetingModalOpen, status } = state.calendar
  const { upcomingEventLoading, meetingDataLoading } = state.loadingStatus
  const { user } = state.user
  return {
    user,
    status,
    cancelMeetingLoading,
    isMeetingModalOpen,
    upcomingEventLoading,
    upComingEvents: getCalendarEvents(
      state.calendar.calendarEvents,
      state.common.totalUpComingMeeting
    ).upComingEvents,
    meetingDataLoading,
    meeting: getTackleMeetingSelector,
  }
}

function upcomingMeetingDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getTackleMeetingEventsAction: getTackleMeetingEventsAction.STARTED,
      totalUpComingMeetingsAction: totalUpComingMeetingsAction,
      cancelUserCalendarEventAction: cancelUserCalendarEventAction.STARTED,
      getUserCalendarEventsAction: getUserCalendarEventsAction.STARTED,
      resetUserCalendarEventsAction: getUserCalendarEventsAction.RESET,
      updateCalendarMeetingAction: updateCalendarMeetingAction.STARTED,
      deleteGoogleCalendarEventAction: deleteGoogleCalendarEventAction.STARTED,
      updateUserCalendarEventAction: updateUserCalendarEventAction.STARTED,
      cancelOutLookMeetingAction: cancelOutLookMeetingAction.STARTED,
    },
    dispatch
  )
}
export const UpcomingMeetingContainer = connect(
  upcomingMeetingProps,
  upcomingMeetingDispatch
)(UpcomingMeeting)

/* --------------------------- Get BoAdvisor (Index) --------------------------- */

const BoAdvisorProps = (state: RootState) => {
  const {
    boAdvisors,
    boAdvisorsLoading,
    userAvailabilityStatus,
    advisorProfile,
    userAvailabilityHoursList,
  } = state.calendar
  const { user } = state
  const { list } = state.clients
  const { isAvailabilityHoursLoading } = state.loadingStatus

  return {
    list,
    boAdvisors: boAdvisors,
    boAdvisorsLoading,
    userAvailabilityList: getUserAvailabilityListSelector(state),
    userAvailabilityStatus,
    advisorProfile,
    userProfile: user.user,
    isAvailabilityHoursLoading,
    userAvailabilityHoursList,
  }
}

function BoAdvisorDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getBoAdvisorAction: getBoAdvisorAction.STARTED,
      updateMeetingStepperAction,
      getUserAvailabilityAction: getUserAvailabilityAction.STARTED,
      getAdvisorProfileAction: getAdvisorProfileAction.STARTED,
      getUserAvailabilityHoursAction: getUserAvailabilityHoursAction.STARTED,
    },
    dispatch
  )
}
export const BoAdvisorContainer = connect(BoAdvisorProps, BoAdvisorDispatch)(BoAdvisor)

const BsoClientProps = (state: RootState) => {
  const { userAvailabilityStatus } = state.calendar
  const { user } = state
  const { list, isAllClientFetching } = state.clients
  return {
    list,
    isAllClientFetching,
    userAvailabilityList: getUserAvailabilityListSelector(state),
    userAvailabilityStatus,
    userProfile: user.user,
  }
}

function BsoClientDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      updateMeetingStepperAction,
      getUserAvailabilityAction: getUserAvailabilityAction.STARTED,
      getAdvisorDashboardAction: getAdvisorDashboardAction.STARTED,
    },
    dispatch
  )
}
export const BsoClientContainer = connect(BsoClientProps, BsoClientDispatch)(BsoClient)

/* -------------------------- PLAYS --------------------------- */
const PlaysProps = (state: RootState) => {
  const {
    play,
    authorizeConnector,
    playStage,
    assessmentResponse,
    isPlayCompleted,
    isUpdateStage,
    isPlayInReview,
    disableButton,
  } = state.play
  const { isPlayLoading } = state.loadingStatus
  const { userConnectors, isScheduled } = state.calendar

  const { user } = state.user
  const businessName = state.user.businessProfile?.businessName
  const industry = state.user.businessProfile?.businessClassification
  return {
    play,
    playStage,
    isScheduled,
    userConnectors,
    currentUser: user,
    authorizeConnector,
    assessmentResponse,
    isPlayCompleted,
    isPlayLoading,
    isUpdateStage,
    isPlayInReview,
    disableButton,
    userSummary: { industry, businessName, userName: user.firstName + ' ' + user.lastName },
  }
}

function PlaysDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getPlayAction: getPlayAction.STARTED,
      getBoAdvisorAction: getBoAdvisorAction.STARTED,
      saveAssessmentResponseAction: saveAssessmentResponseAction.STARTED,
      authorizeConnectorAction: authorizeConnectorAction.STARTED,
      updatePlayStageAction: updatePlayStageAction.STARTED,
      getUserMeetingAction: getUserMeetingAction.STARTED,
      getPlayAssessmentResponseAction: getPlayAssessmentResponseAction.STARTED,
      resetPlayAction: resetPlayAction,
      getPlayResponseAction: getPlayResponseAction.STARTED,
    },
    dispatch
  )
}
export const PlaysContainer = connect(PlaysProps, PlaysDispatch)(Plays)

/* -------------------------- PLAYVIEW-CONTAINER --------------------------- */
const PlayViewProps = (state: RootState) => {
  const { userConnectors, oAuthUrl, isConnected, isScheduled, isToolConnectionSuccessLoading } =
    state.calendar
  const {
    authorizeConnector,
    isPlayCompleted,
    playSteps,
    playResponseData,
    isPlayInReview,
    disableButton,
  } = state.play
  const { user } = state.user
  const { uploadedFile, uploadFileErrors } = state.common
  const { isPlayDataSaving } = state.loadingStatus

  return {
    disableButton,
    isPlayInReview,
    playResponseData,
    playSteps,
    currentUser: user,
    isConnected,
    oAuthUrl,
    isScheduled,
    userConnectors,
    isPlayCompleted,
    isPlayDataSaving,
    authorizeConnector,
    uploadedFile,
    uploadFileErrors,
    playValue: getPlayValue(state),
    isToolConnectionSuccessLoading,
  }
}

function PlayViewDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      resetOAuthUrlAction,
      handleCyclrOAuthAction: handleCyclrOAuthAction.STARTED,
      toolConnectionSuccessAction: toolConnectionSuccessAction.STARTED,
      getUserConnectorsAction: getUserConnectorsAction.STARTED,
      authorizeConnectorAction: authorizeConnectorAction.STARTED,
      getConnectedPlayAction: getConnectedPlayAction.STARTED,
      getAssessmentResponseByQuestionAction: getAssessmentResponseByQuestionAction.STARTED,
      getUserMeetingAction: getUserMeetingAction.STARTED,
      handleCompletePlayAction: handleCompletePlayAction.STARTED,
      savePlayDataAction: savePlayDataAction.STARTED,
      uploadFileAction: uploadFileAction.STARTED,
      getOAuthUrlAction: getOAuthUrlAction.STARTED,
      resetPlayAction: resetPlayAction,
      savePlayResponseAction: savePlayResponseAction.STARTED,
    },
    dispatch
  )
}
export const PlayViewContainer = connect(PlayViewProps, PlayViewDispatch)(PlayView)

/* -------------------------- PlaysAuthentication-CONTAINER --------------------------- */
const PlaysAuthenticationProps = (state: RootState) => {
  const { user } = state.user
  const { uploadFileLoading } = state.play
  const { savePlayDataError } = state.loadingStatus
  const { isPlayResponseLoading } = state.owner
  return {
    playResponse: getPlayResponse(state),
    savePlayDataError,
    isPlayResponseLoading,
    uploadFileLoading,
    currentUser: user,
  }
}

function PlaysAuthenticationDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getConnectedPlayAction: getConnectedPlayAction.STARTED,
      handleCyclrOAuthAction: handleCyclrOAuthAction.STARTED,
      savePlayDataAction: savePlayDataAction.STARTED,
      getUserConnectorsAction: getUserConnectorsAction.STARTED,
      resetOAuthUrlAction: resetOAuthUrlAction,
      saveUserPlayFileAction: saveUserPlayFileAction.STARTED,
      resetUploadFileAction: uploadFileAction.RESET,
      resetSavePlayDataError: savePlayDataAction.RESET,
      setToolConnectionStatus: setToolConnectionStatus,
    },
    dispatch
  )
}
export const PlaysAuthenticationContainer = connect(
  PlaysAuthenticationProps,
  PlaysAuthenticationDispatch
)(PlaysAuthentication)
/* -------------------------- Schedule Meeting-CONTAINER --------------------------- */
const PlaysScheduleMeetingProps = (state: RootState) => {
  const { userConnectors, meetingStepper } = state.calendar

  return {
    userConnectors,
    meetingStepper,
  }
}

function PlaysScheduleMeetingDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      setIsScheduledAction,
      getUserConnectorsAction: getUserConnectorsAction.STARTED,
      savePlayResponseAction: savePlayResponseAction.STARTED,
      updateMeetingStepperAction,
      getPlayResponseAction: getPlayResponseAction.STARTED,
    },
    dispatch
  )
}
export const PlayScheduleMeetingContainer = connect(
  PlaysScheduleMeetingProps,
  PlaysScheduleMeetingDispatch
)(PlaysScheduleMeeting)

/* -------------------------- Tools CONTAINER --------------------------- */
const toolsProps = (state: RootState) => {
  let { user } = state.user
  return {
    ownerExperience: user?.ownerExperience,
    completedToolsCount: getCompletedToolsCountSelector(state),
  }
}

const ToolsDispatch = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      updateMyToolsAction: updateMyToolsAction.STARTED,
    },
    dispatch
  )
}
export const ToolsContainer = connect(toolsProps, ToolsDispatch)(Tools)

/* --------------------------  Connected Tools CONTAINER --------------------------- */
const connectedToolsProps = (state: RootState) => {
  const { oAuthUrl } = state.calendar
  const { clientConnectedTools } = state.clients
  const { myToolsLoading } = state.loadingStatus
  return {
    myTools: getGroupedMyToolsByCategory(state),
    oAuthUrl,
    myToolsLoading,
    clientConnectedTools,
  }
}

const connectedToolsDispatch = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      resetOAuthUrlAction,
      getOAuthUrlAction: getOAuthUrlAction.STARTED,
      getUserConnectorsAction: getUserConnectorsAction.STARTED,
      getConnectedToolsAction: getConnectedToolsAction.STARTED,
      deauthenticateConnectorAction: deauthenticateConnectorAction.STARTED,
      subscribeGoogleCalendarWebhookAction: subscribeGoogleCalendarWebhookAction.STARTED,
      toolConnectionSuccessAction: toolConnectionSuccessAction.STARTED,
      getMyToolsAction: getMyToolsAction.STARTED,
    },
    dispatch
  )
}
export const ConnectedToolsContainer = connect(
  connectedToolsProps,
  connectedToolsDispatch
)(ConnectedTools)

/* --------------------------  All Tools CONTAINER --------------------------- */
const allToolsProps = (state: RootState) => {
  const { clientConnectedTools } = state.clients
  const { allToolsLoading } = state.loadingStatus
  const { oAuthUrl } = state.calendar

  return {
    allToolsLoading: allToolsLoading,
    oAuthUrl,
    allTools: getGroupedAllToolsByCategory(state),
    clientConnectedTools,
  }
}

const allToolsDispatch = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      getMyToolsAction: getMyToolsAction.STARTED,
      getOAuthUrlAction: getOAuthUrlAction.STARTED,
      resetOAuthUrlAction: resetOAuthUrlAction,
      getUserConnectorsAction: getUserConnectorsAction.STARTED,
      getAllToolsAction: getAllToolsAction.STARTED,
      toolConnectionSuccessAction: toolConnectionSuccessAction.STARTED,
      subscribeGoogleCalendarWebhookAction: subscribeGoogleCalendarWebhookAction.STARTED,
      deauthenticateConnectorAction: deauthenticateConnectorAction.STARTED,
    },
    dispatch
  )
}
export const AllToolsContainer = connect(allToolsProps, allToolsDispatch)(AllTools)

/* --------------------------  All Tools Block CONTAINER --------------------------- */
const allToolsBlockProps = (state: RootState) => {
  return {}
}

const allToolsBlockDispatch = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      getOAuthUrlAction: getOAuthUrlAction.STARTED,
    },
    dispatch
  )
}
export const AllToolsBlockContainer = connect(
  allToolsBlockProps,
  allToolsBlockDispatch
)(AllToolsBlock)

/* --------------------------  All Tools Modal CONTAINER --------------------------- */
const allToolsModalProps = (state: RootState) => {
  const { allTools } = state.clients
  return {
    allTools,
  }
}

const allToolsModalDispatch = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      getAllToolsAction: getAllToolsAction.STARTED,
      updateMyToolsAction: updateMyToolsAction.STARTED,
    },
    dispatch
  )
}
export const AllToolsModalContainer = connect(
  allToolsModalProps,
  allToolsModalDispatch
)(AllToolsModal)

/* --------------------------  Tools Guide Modal CONTAINER --------------------------- */
const toolsGuideProps = (state: RootState) => {
  return {}
}

const toolsGuideDispatch = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      updateMyToolsAction: updateMyToolsAction.STARTED,
    },
    dispatch
  )
}
export const ToolsGuideContainer = connect(toolsGuideProps, toolsGuideDispatch)(ToolsGuide)

/* --------------------------  Tool Flyout Menu CONTAINER --------------------------- */
const toolFlyOutMenuProps = (state: RootState) => {
  const { myTools, allTools } = state.clients
  return {
    myTools,
    allTools,
    toolDetail: getToolDetail(state),
  }
}

const toolFlyOutMenuDispatch = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      getAllToolsAction: getAllToolsAction.STARTED,
      getMyToolsAction: getMyToolsAction.STARTED,
    },
    dispatch
  )
}
export const ToolFlyOutMenuContainer = connect(
  toolFlyOutMenuProps,
  toolFlyOutMenuDispatch
)(ToolFlyoutMenu)
